import loadable from '@loadable/component';


// import { Water, DropletFill, ClockHistory, ArrowLeftCircleFill, ArrowRightCircleFill } from 'react-bootstrap-icons';
import {
	ArrowLeftCircleFill,
	ArrowRightCircleFill,
	Cloud,
	CloudRain
} from 'react-bootstrap-icons';

export const FMUpstreamIcon = function(props) {
	return <ArrowLeftCircleFill {...props} />;
}

export const FMDownstreamIcon = function(props) {
	return <ArrowRightCircleFill {...props} />;
}

export const FMNoRain = function(props) {
	return <Cloud {...props} />
}

export const FMRainfallStation = function(props) {
	return <CloudRain {...props} />
}